import * as Configuration from '../../app.constants.js';

export class SearchService {
  constructor($http) {
    this.$http = $http;
  }

  getSelectorsData(companyId){
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/search/selectors-data');
  }


  static SearchFactory($http) {
    return new SearchService($http);
  }
}
SearchService.SearchFactory.$inject = ['$http'];
